import { faWindowRestore } from '@fortawesome/free-regular-svg-icons';
import { faGamepad, faPrint, faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Tab from 'react-bootstrap/lib/Tab';
import Tabs from 'react-bootstrap/lib/Tabs';
import CopyAttributionLink from '../CopyAttributionLink';
import I18nLink from '../I18nLink';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { device } from '~/utils';

@withI18next()
class AttributeModal extends React.Component {
  state = {
    key: 1,
  };

  handleSelectTab(key) {
    this.setState({ key });
  }

  handleCopyLink() {
    if (!process.browser) return;
    const text = `${window.location.href}`;
    if (window.navigator && window.navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      device.copyToClipboard(text);
    }
  }

  renderResource() {
    if (!process.browser) return null;
    const { t, photo } = this.props;
    const { nickname } = photo.creator;
    const text = t(Config.getPrefixContent('image_by_raw_text'), {
      creatorName: nickname,
    });
    return text;
  }

  renderLinkPhoto() {
    if (!process.browser) return;
    const { t, photo } = this.props;
    return `${window.location.href}`;
  }

  render() {
    const { t, modal, handleClose, photo, lng } = this.props;

    return (
      <Modal
        bsSize="large"
        show={modal}
        onHide={() => this.props.handleClose(false)}
        className="attribute-modal"
      >
        <Modal.Body>
          <div className="attribute-modal-content">
            {/* <button className="button-close" onClick={() => this.props.handleClose(false)}>
              &#x2715;
            </button> */}
            <div className="paragraph-readable push-center">
              <h2 style={{ textAlign: 'center' }}>{t('how_to_attribute')}</h2>
              <p style={{ textAlign: 'center' }}>
                {t('popup_attribute_content')}
              </p>
            </div>
            <div style={{ minHeight: 250 }}>
              <Tabs
                activeKey={this.state.key}
                onSelect={this.handleSelectTab.bind(this)}
              >
                <Tab eventKey={1} title={t('Web')}>
                  <div className="according-content">
                    <div
                      style={{
                        fontSize: 14,
                        textAlign: 'center',
                        fontWeight: '700',
                        marginBottom: '10px',
                      }}
                    >
                      <FontAwesomeIcon
                        className="icon-large"
                        icon={faWindowRestore}
                      />
                      <br />
                      {t('content_nav_web')}
                    </div>

                    <div className="paragraph-readable push-center">
                      <p style={{ textAlign: 'center', marginBottom: '10px' }}>
                        {t('sub_content_nav_web')}
                      </p>
                      <CopyAttributionLink photo={photo} />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey={4} title={t('app_game')}>
                  <div className="according-content">
                    <div
                      style={{
                        fontSize: 14,
                        textAlign: 'center',
                        fontWeight: '700',
                        marginBottom: '10px',
                      }}
                    >
                      <FontAwesomeIcon
                        className="icon-large"
                        icon={faGamepad}
                      />
                      <br />
                      {t('content_nav_app_game')}
                    </div>
                    <div className="paragraph-readable push-center">
                      <p style={{ textAlign: 'center', marginBottom: '10px' }}>
                        <strong>{t('paste_this_link')}</strong>{' '}
                        {t('sub_content_nav_app_game')}
                      </p>
                      <CopyAttributionLink photo={photo} />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey={2} title={t('printed_element')}>
                  <div className="according-content">
                    <div
                      style={{
                        fontSize: 14,
                        textAlign: 'center',
                        fontWeight: '700',
                        marginBottom: '10px',
                      }}
                    >
                      <FontAwesomeIcon className="icon-large" icon={faPrint} />
                      <br />
                      {t('content_printed_element')}
                    </div>

                    <div className="paragraph-readable push-center">
                      <p style={{ textAlign: 'center', marginBottom: '10px' }}>
                        <strong>{t('insert_this_line')}</strong>{' '}
                        {t('close_credit_section')}
                      </p>
                      <p style={{ textAlign: 'center' }}>
                        {t('attribute_popup_resource', {
                          domain: this.renderResource(),
                        })}
                      </p>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey={3} title={t('nav_video')}>
                  <div className="according-content">
                    <div
                      style={{
                        fontSize: 14,
                        textAlign: 'center',
                        fontWeight: '700',
                        marginBottom: '10px',
                      }}
                    >
                      <FontAwesomeIcon className="icon-large" icon={faVideo} />
                      <br />
                      {t('online_video')}
                    </div>

                    <div className="paragraph-readable push-center">
                      <p style={{ textAlign: 'center', marginBottom: '10px' }}>
                        {t('paste_link_appro')}
                      </p>

                      <CopyAttributionLink photo={photo} />
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="attribute-modal-footer">
            <div className="dont-want-to-credit-author">
              <div className="text-4">{t('crediting_is_required_4')}</div>
              <div className="text-5">
                <I18nLink href={{ pathname: '/premium' }}>
                  <a
                    className={`btn btn-ac-primary btn-${Config.serviceType} button-premium-credit`}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t('crediting_is_required_5'),
                      }}
                    />
                  </a>
                </I18nLink>
              </div>
            </div>
          </div>
        </Modal.Footer>
        <style jsx global>
          {`
            .attribute-modal .attribute-modal-content {
              position: relative;
            }
            .attribute-modal .attribute-modal-content .nav-tabs > li > a,
            .attribute-modal .attribute-modal-content .nav-tabs > li > a:hover,
            .attribute-modal .attribute-modal-content .nav-tabs > li > a:active,
            .attribute-modal .attribute-modal-content .nav-tabs > li > a:focus {
              background: transparent !important;
              border-left: none;
              border-right: none;
              border-top: none;
              border: none;
              border-bottom: 1px solid transparent;
            }
            .attribute-modal .attribute-modal-content .button-close {
              width: 32px;
              height: 32px;
              border-radius: 16px;
              top: -53px;
              right: -33px;
              position: absolute;
              border: none;
            }
            .attribute-modal .attribute-modal-content .nav-tabs > li.active > a,
            .attribute-modal
              .attribute-modal-content
              .nav-tabs
              > li.active
              > a:hover,
            .attribute-modal
              .attribute-modal-content
              .nav-tabs
              > li.active
              > a:active,
            .attribute-modal
              .attribute-modal-content
              .nav-tabs
              > li.active
              > a:focus {
              color: #555;
              cursor: default;
              border-left: none;
              border-right: none;
              border-top: none;
              border: none;
              border-bottom: 1px solid #4a4a4a !important;
            }
            .attribute-modal .attribute-modal-content .alignc {
              text-align: center;
            }
            .attribute-modal .attribute-modal-content a {
              color: #4a4a4a;
            }
            .attribute-modal .attribute-modal-content .according-content {
              padding-left: 20px;
              padding-right: 20px;
              padding-top: 30px;
            }
            .attribute-modal .attribute-modal-content .paragraph-readable {
              max-width: 768px;
            }
            .attribute-modal .attribute-modal-content .push-center {
              margin-left: auto;
              margin-right: auto;
            }
            .attribute-modal .attribute-modal-content .copy-text {
              -webkit-box-flex: 1;
              padding: 13px;
              flex: 1;
              border: 1px solid #dfdfdf;
              border-right-width: 0;
              border-radius: 3px 0 0 3px;
              background-color: #f9f9f9;
            }
            .attribute-modal .attribute-modal-content .copy {
              display: flex;
              flex-direction: row;
              justify-content: center;
            }
            .attribute-modal .attribute-modal-content .button-copy {
              display: flex;
              padding: 0 1.3em;
              border: 1px solid #0f73ee;
              border-radius: 0 3px 3px 0;
              justify-content: space-between;
              align-items: center;
              background-color: #0f73ee;
            }
            .attribute-modal .attribute-modal-content .icon-small {
              width: 16px;
              height: 16px;
              margin-left: 5px;
              margin-right: auto;
            }
            .attribute-modal .attribute-modal-content .icon-large {
              width: 30px;
              height: 30px;
              margin-left: 5px;
              margin-right: auto;
            }
            .attribute-modal .attribute-modal-content .text-copy {
              color: #ffffff;
            }
            .attribute-modal .attribute-modal-content .other-question {
              padding-top: 20px;
              margin-left: auto;
              margin-right: auto;
              padding-bottom: 0;
              margin-top: 50px;
            }
            .attribute-modal .attribute-modal-content ul.nav.nav-tabs {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
            }

            .attribute-modal .modal-footer {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/ads/0-1.png);
              background-position: left top;
            }
            .attribute-modal .modal-footer .attribute-modal-footer {
              display: flex;
              justify-content: center;
              text-align: center;
              padding: 20px 0px;
            }
            .attribute-modal
              .modal-footer
              .attribute-modal-footer
              .dont-want-to-credit-author {
              font-size: 20px;
              color: white;
              font-weight: bold;
            }
            .attribute-modal
              .modal-footer
              .attribute-modal-footer
              .dont-want-to-credit-author
              .text-4 {
              margin-bottom: 10px;
            }
            .attribute-modal
              .modal-footer
              .attribute-modal-footer
              .dont-want-to-credit-author
              .text-5
              .icon-premium-after-download {
              margin-bottom: 5px;
            }
          `}
        </style>
      </Modal>
    );
  }
}

export default AttributeModal;
